import styled, { css } from "styled-components"

export default {
    "Content": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;

        & > p {
            ${({ theme }) => theme.font["small-medium"]};
            color: ${({ theme }) => theme.color["grey3"]};
        }
    `,

    "ProfileButton": styled.button`
        position: relative;
        width: fit-content;
    `,
    "ProfileImage": styled.img`
        width: 120px;
        height: 120px;
        cursor: pointer;
        border-radius: 50%;
        object-fit: cover;
        object-position: center center;
    `,
    "ProfileOption": styled.img`
        position: absolute;
        right: -6px;
        bottom: 5px;
        width: 40px;
    `,
}